import React from 'react';
import './BattleUnitEquipment.css';

interface EquipmentItem {
  itemName: string;
  imageUrl?: string;
  iconName?: string;
  attackBonus: number;
  defenseBonus: number;
  hpBonus: number;
  speedBonus: number;
}

interface BattleUnitEquipmentProps {
  equipment: {
    weapon?: EquipmentItem;
    armor?: EquipmentItem;
    accessory?: EquipmentItem;
  };
  isPlayerUnit: boolean;
}

const BattleUnitEquipment: React.FC<BattleUnitEquipmentProps> = ({ equipment, isPlayerUnit }) => {
  if (!isPlayerUnit) {
    return null; // Don't show equipment for enemy units
  }

  const getItemTypeIcon = (itemType: string): string => {
    switch (itemType.toLowerCase()) {
      case 'weapon': return '⚔️';
      case 'armor': return '🛡️';
      case 'accessory': return '💍';
      default: return '📦';
    }
  };

  const renderEquipmentIcon = (item: EquipmentItem | undefined, type: string) => {
    if (!item) {
      return null;
    }

    return (
      <div 
        key={type}
        className={`battle-equipment-icon ${type.toLowerCase()}`}
      >
        {item.imageUrl ? (
          <img 
            src={item.imageUrl} 
            alt={item.itemName}
            className="equipment-image"
            onError={(e) => {
              const target = e.currentTarget as HTMLImageElement;
              const fallback = target.nextElementSibling as HTMLDivElement;
              target.style.display = 'none';
              if (fallback) {
                fallback.style.display = 'block';
              }
            }}
          />
        ) : null}
        <div className="equipment-fallback" style={{ display: item.imageUrl ? 'none' : 'block' }}>
          {getItemTypeIcon(type)}
        </div>
        <div className={`equipment-type-indicator ${type.toLowerCase()}`} />
      </div>
    );
  };

  const hasAnyEquipment = equipment.weapon || equipment.armor || equipment.accessory;

  if (!hasAnyEquipment) {
    return null;
  }

  return (
    <div className="battle-unit-equipment">
      {renderEquipmentIcon(equipment.weapon, 'weapon')}
      {renderEquipmentIcon(equipment.armor, 'armor')}
      {renderEquipmentIcon(equipment.accessory, 'accessory')}
    </div>
  );
};

export default BattleUnitEquipment;